import { relayEmailOAuthCallback } from './services/email-oauth-relay'

if (!relayEmailOAuthCallback()) {
  import('./app-bootstrap')
}
